import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { GlobalState } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: GlobalState = {
  user: JSON.parse(localStorage.getItem('user') || 'null') || null,
  loading: false,
  error: null,
  settings: JSON.parse(localStorage.getItem('settings') || 'null') || null,
};

const slice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<any>) {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
    },
    setSettings: (state, action: PayloadAction<any>) => {
      localStorage.setItem('settings', JSON.stringify(action.payload));
      state.settings = action.payload;
    },
  },
});

export const api = createApi({
  reducerPath: 'globalApi',
  baseQuery,
  endpoints: builder => ({
    getCountries: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.COUNTRIES,
          method: 'GET',
        };
      },
    }),
    getSettings: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.OPTIONS,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { actions: globalActions } = slice;

export const useGlobalSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: slice.actions,
    useGetSettingsQuery: api.useLazyGetSettingsQuery,
    useGetCountriesQuery: api.useLazyGetCountriesQuery,
  };
};
